var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTimes = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0,0,256,256",
    width: "20px",
    height: "20px",
    fillRule: "nonzero",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    strokeMiterlimit: 10,
    fontFamily: "none",
    fontSize: "none",
    fontWeight: "none",
    style: {
      mixBlendMode: "normal"
    },
    textAnchor: "none"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m192.112 45.034 18.86 18.86L63.892 210.97l-18.86-18.86z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M210.958 192.122 192.1 210.976 45.038 63.874 63.897 45.02z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTimes);
export default ForwardRef;